import { createAction, props } from '@ngrx/store';
import { SendBulkMailRequest } from './../models/bulk-email-request';
import { SendBulkMailResponse } from '../models/bulk-email-response';
import { AppError } from '../errors/app-error';

export const sendBulkMail = createAction('[Bulk Mail] Send Bulk Mail', props<SendBulkMailRequest>());
export const sendBulkMailSuccess = createAction('[Bulk Mail] Send Bulk Mail Success', props<{ response: SendBulkMailResponse }>());
export const sendBulkMailFailure = createAction('[Bulk Mail] Send Bulk Mail Failure', props<{ error: AppError }>());
export const initializeSendBulkMailState = createAction('[Bulk Mail] Initialize Send Bulk Mail State');
